var map = {
	"./icon-0.png": "842d",
	"./icon-1.png": "5b1d",
	"./icon-2.png": "1bb6",
	"./icon-3.png": "db42",
	"./icon-4.png": "55cc",
	"./icon-5.png": "1bdc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e47b";